import axios from "axios";
import VueCookie from "vue-cookie";
import router from "../routes/router";
const qs = require("querystring");

const HttpMethod = {
    Get: "GET",
    Post: "POST",
    Put: "PUT",
    Delete: "DELETE"
};

let axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 300000
});

axiosInstance.interceptors.request.use(
    function(config) {
        // if ( config.method === "POST" || config.method === "PATCH" || config.method === "PUT") {
        //     config.headers["Content-Type"] = "application/json;charset=utf-8";
        // }

        if (VueCookie.get("token") != "") {
            config.headers["Authorization"] = "Bearer " + VueCookie.get("token");
        }

        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
    function(response) {
        // Do something with response data
        return response;
    },
    function(error) {
        // Do something with response error
        if (error.response.status === 401) {
            router.push("/login");
        }
        return Promise.reject(error);
    }
);

class HttpRequest {

    request(method,url, payload) {
        let promise = null;

		// Check Payload is formdata
		if (payload instanceof FormData) {
			if (method === HttpMethod.Post) {
				axiosInstance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
			} else if (method === HttpMethod.Put) {
				axiosInstance.defaults.headers.put['Content-Type'] = 'multipart/form-data';
			}
		} else {
			if (method === HttpMethod.Post) {
				axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
			} else if (method === HttpMethod.Put) {
				axiosInstance.defaults.headers.put['Content-Type'] = 'application/json';
			}

		}

        switch (method) {
            case HttpMethod.Get:
                promise = axiosInstance.get(url, {params : payload});
                break;
            case HttpMethod.Post:
                promise = axiosInstance.post(url, payload);
                break;
            case HttpMethod.Put:
                promise = axiosInstance.put(url, payload);
                break;
            case HttpMethod.Delete:
                promise = axiosInstance.delete(url, payload);
                break;
            default:
                promise = axiosInstance.get(url, payload);
                break;
        }
        return promise;
    }
}

export { HttpRequest, HttpMethod };
